import { SET_DARKMODE } from '../../reducers/constants';

export const setDarkmode = () => (dispatch) => {
  dispatch({
    type: SET_DARKMODE,
  });
};
